import React, { FC, memo } from 'react'

import { useNavigate } from 'react-router-dom'

import { Button } from '@/components/Button/Button'
import { LoginHeader } from '@/components/LoginHeader'
import { DescriptionQr } from '@/components/QrCode/DescriptionQr'
import { QrCode } from '@/components/QrCode/QrCode'
import { icons } from '@/constants/icons'
import { titleData } from '@/constants/login'
import { paths } from '@/constants/paths'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'
import useStore from '@/store/useStore'
import { LoginSessionProps } from '@/types/componentsPropsTypes'
import { getMainHomePath } from '@/utils/route'

import {
  LoginWrapper,
  PromoWrapper,
  LoginContainer,
  PromoImg,
  QrContainerLogin,
  ButtonWrapper,
  TextElem,
  LoginSkipWrapper,
} from './styles'
import { QrWrapperMobileBg } from '../styles'

const LoginSessionRow: FC<LoginSessionProps> = ({
  code,
  qrUrl,
  qrCodeUrl,
  remainingTime,
  promotionData,
  isRegisterButtonHidden,
}) => {
  const navigate = useNavigate()
  const { t } = useCommonTranslation()

  const goToRegister = () => navigate(`${paths.REGISTER}`)
  const goToHome = () => navigate(getMainHomePath())
  const authPopup = useStore((state) => state.common.authPopup)

  const loginHeaderTitle = authPopup?.title || t(titleData.created_login.title)
  const loginHeaderDescription =
    authPopup?.description || t(titleData.created_login.description)

  return (
    <LoginContainer $promotionData={!!promotionData}>
      {promotionData && (
        <PromoWrapper>
          <PromoImg src={icons.register.promoRegisterImage} alt="" />
        </PromoWrapper>
      )}
      <LoginWrapper $promotionData={!!promotionData}>
        <LoginHeader
          showLogo={false}
          title={loginHeaderTitle}
          description={loginHeaderDescription}
        />
        <QrContainerLogin>
          <QrWrapperMobileBg>
            {qrCodeUrl && <QrCode qrPath={qrCodeUrl} />}
          </QrWrapperMobileBg>
          <DescriptionQr
            link={qrUrl}
            code={code}
            mobileStyle={true}
            remainingTime={remainingTime}
          />
        </QrContainerLogin>
        {!isRegisterButtonHidden && (
          <ButtonWrapper>
            <TextElem>{t('dontHaveAccount')}</TextElem>
            <Button
              iconSrc={icons.navigation.profile}
              text={t('register')}
              onClick={goToRegister}
            />
            {promotionData && (
              <LoginSkipWrapper>
                <Button text={t('skip')} onClick={goToHome} />
              </LoginSkipWrapper>
            )}
          </ButtonWrapper>
        )}
      </LoginWrapper>
    </LoginContainer>
  )
}

export const LoginSession = memo(LoginSessionRow)
